var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBlackHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1A1A1A",
  fillRule: "evenodd",
  d: "M10.004 2.09c1.76-2.06 5.02-2.9 7.66-1.1 1.4.96 2.28 2.58 2.34 4.28.13 3.88-3.3 6.99-8.55 11.75l-.11.1c-.76.7-1.93.7-2.69.01l-.1-.09-.06-.054C3.278 12.246-.136 9.146.004 5.28c.06-1.71.94-3.33 2.34-4.29 2.64-1.81 5.9-.96 7.66 1.1m0 13.56.1-.1c4.76-4.31 7.9-7.16 7.9-10.05 0-2-1.5-3.5-3.5-3.5-1.54 0-3.04.99-3.56 2.36h-1.87C8.544 2.99 7.044 2 5.504 2c-2 0-3.5 1.5-3.5 3.5 0 2.89 3.14 5.74 7.9 10.05z",
  clipRule: "evenodd"
})));
export default SvgBlackHeart;